import { Component, OnInit, ViewChild } from '@angular/core'
import {
  EntityGroupFeeScheduleODataService,
  FeeScheduleODataService,
  IEntityGroupFeeSchedule,
  IFeeSchedule
} from '@exchange/domain/.'
import { ActivatedRoute } from '@angular/router'
import { EntityGroupFeeScheduleCodesModalComponent } from './entity-group-fee-schedule-codes-modal.component'
import { BsModalService } from 'ngx-bootstrap/modal'
import { ToastrService } from 'ngx-toastr'
import {
  GridSize,
  GridWrapperComponent,
  SingleRowSelection,
  ViewButtonColumnRendererComponent
} from 'common-components'

@Component({
  selector: 'app-entity-group-edit-feeschedules',
  templateUrl: './entity-group-edit-feeschedules.component.html',
  standalone: false
})
export class EntityGroupEditFeeschedulesComponent implements OnInit {
  @ViewChild('available', { static: true }) available: GridWrapperComponent
  @ViewChild('selected', { static: true }) selected: GridWrapperComponent
  entityGroupFeeSchedules: IEntityGroupFeeSchedule[] = []
  availableSelection: IFeeSchedule = null
  entityGroupId: number = null
  GridSize = GridSize

  private _gridOptions = {
    canEdit: false,
    canDelete: false,
    viewHandler: this.viewDetails.bind(this)
  }

  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private feeScheduleService: FeeScheduleODataService,
    private entityGroupFeeScheduleService: EntityGroupFeeScheduleODataService,
    private toastr: ToastrService
  ) {}

  initializeAvailable() {
    this.available.gridOptions.context = this._gridOptions
    this.available.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ViewButtonColumnRendererComponent
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Active On',
        field: 'ActiveOnDateTime',
        width: 100,
        cellRenderer: GridWrapperComponent.DateWithoutTimeRenderer(),
        filter: 'agDateColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Expires On',
        field: 'ExpiresOnDateTime',
        width: 100,
        cellRenderer: GridWrapperComponent.DateWithoutTimeRenderer(),
        filter: 'agDateColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.available.gridOptions.rowSelection = SingleRowSelection
    this.available.gridOptions.onSelectionChanged = () => {
      const selectedRows = this.available.api.getSelectedRows()
      this.availableSelection = selectedRows.length ? (selectedRows[0] as IFeeSchedule) : null
    }

    this.available.odata = this.feeScheduleService
  }

  initializeSelected() {
    this.entityGroupFeeScheduleService
      .query()
      .filter(`EntityGroupId eq ${this.entityGroupId}`)
      .expand('FeeSchedule')
      .exec()
      .subscribe(response => {
        this.entityGroupFeeSchedules = response.data
      })
  }

  ngOnInit() {
    this.entityGroupId = +this.route.snapshot.params['id']

    this.initializeAvailable()
    this.initializeSelected()
  }

  select() {
    const item = {
      EntityGroupId: this.entityGroupId,
      FeeScheduleId: this.availableSelection.Id,
      Start: this.availableSelection.ActiveOnDateTime,
      End: this.availableSelection.ExpiresOnDateTime
    } as IEntityGroupFeeSchedule

    this.entityGroupFeeScheduleService
      .post(item)
      .exec()
      .subscribe(
        response => {
          this.toastr.success('Fee Schedule added')
          response.FeeSchedule = this.availableSelection
          this.entityGroupFeeSchedules.push(response)
        },
        () => {
          this.toastr.error('Fee Schedule could not be added')
        }
      )
  }

  viewDetails(feeSchedule: IFeeSchedule) {
    this.modalService.show(EntityGroupFeeScheduleCodesModalComponent, {
      initialState: {
        feeSchedule
      },
      class: 'modal-large'
    })
  }
}
